
<!-- Profile Block -->
<nz-card class="w-100-pc d-b" [nzTitle]="'John Grisham'" [nzExtra]="extraTemplate">
  <p><b>ID:</b> 32090</p>
  <p><b>Role:</b> Admin User</p>
  <p><b>Last Profile Update:</b> 30 April 2020 10:18 AM</p>
  <p><b>Last Password Update:</b> 30 April 2020 10:15 AM</p>
</nz-card>
<ng-template #extraTemplate></ng-template>

<!-- Separator -->
<nz-divider [nzText]="'Configure'" [nzOrientation]="'left'" class="p-t-b-20"></nz-divider>

<!-- Tabs for Settings (add/remove as per requirement) -->
<nz-tabset [nzTabPosition]="'top'" [nzType]="'card'">

  <!-- Update Password -->
  <nz-tab [nzTitle]="'Update Password'">
    <form>
      <nz-form-item>
        <nz-form-label [nzSpan]="5" nzRequired nzFor="note">Existing Password</nz-form-label>
        <nz-form-control [nzSpan]="12">
          <input id="passOld" type="password" nz-input>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="5" nzRequired nzFor="note">New Password</nz-form-label>
        <nz-form-control [nzSpan]="12">
          <input id="passNew" type="password" nz-input>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="5" nzRequired nzFor="note">Retype New Password</nz-form-label>
        <nz-form-control [nzSpan]="12">
          <input id="passRe" type="password" nz-input>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control [nzSpan]="12" [nzOffset]="5">
          <button nz-button nzType="primary">Update</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </nz-tab>

  <!-- User: Profile fields edit -->
  <nz-tab [nzTitle]="'Profile'">
    <form>
      <nz-form-item>
        <nz-form-label [nzSpan]="5" nzRequired nzFor="fname">First Name</nz-form-label>
        <nz-form-control [nzSpan]="12">
          <input id="fname" type="text" nz-input value="John" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="5" nzFor="lname">Last Name</nz-form-label>
        <nz-form-control [nzSpan]="12">
          <input id="lname" type="text" nz-input value="Grisham" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control [nzSpan]="12" [nzOffset]="5">
          <button nz-button nzType="primary">Update Profile</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </nz-tab>

</nz-tabset>
